import React, {FC} from 'react';

import {Panel} from './Panel';
import {PanelContextProvider} from './PanelContextProvider';
import {PanelContainerProps} from './types';

/**
 * This component is used in both workspaces and reports.
 * Make sure that panel grid in reports still works when changes are made.
 */
export const PanelContainer: FC<PanelContainerProps> = ({
  defaultMoveToSectionRef,
  disableRunLinks,
  inheritedSettings,
  isReadOnly,
  isProjectReadOnly,
  loadingState,
  mode,
  onContentHeightChange,
  panelBankSectionConfigRef,
  panelRef,
  shouldRenderContent,
  shouldTurnOnComments,
}) => {
  return (
    // // Dummy div for testing -- use this if you want to render placeholder boxes without charts
    // <div style={{border: '1px solid'}} draggable="true" className="blank-box">
    //   <DragHandle className="draggable-handle" partRef={panelRef}>
    //     <WBIcon name="handle" />
    //   </DragHandle>
    //   {panelRef.id}
    // </div>

    <PanelContextProvider
      isReadOnly={isReadOnly}
      isProjectReadOnly={isProjectReadOnly}
      loadingState={loadingState}
      panelBankSectionConfigRef={panelBankSectionConfigRef}
      panelRef={panelRef}
      inheritedSettings={inheritedSettings}>
      <Panel
        currentHeight={0}
        defaultMoveToSectionRef={defaultMoveToSectionRef}
        disableRunLinks={disableRunLinks}
        key={panelRef.id}
        onContentHeightChange={onContentHeightChange}
        shouldRenderContent={shouldRenderContent}
        shouldTurnOnComments={!!shouldTurnOnComments}
        mode={mode}
      />
    </PanelContextProvider>
  );
};
